module.exports = __webpack_public_path__ + "static/img/alipaylogo.57b9f335.png";